<template>
  <div
    v-editable="link"
    class="flex space-x-4 scrollbar-hide sm:justify-center"
  >
    <FimButton
      :type="link.type"
      :to="ctaURLHandler(link, $currentShop)"
      is-small
      :theme="theme"
      :target="target"
      @click.stop="clickObserver(trackingData)"
    >
      {{ link.label }}
    </FimButton>
  </div>
</template>

<script setup lang="ts">
import FimButton from '~/components/ui/buttons/FimButton.vue'
import type { StoryblokTrackingContent } from '~/storyblok/types/storyblok'
import type { SbBannerLink } from '~/storyblok/types/storyblok.gen'
import { ctaURLHandler } from '~/storyblok/utils/links'
import { isStoryblokTrackingContent } from '~/utils/typeguards'

const props = defineProps({
  link: {
    type: Object as PropType<SbBannerLink>,
    required: true,
  },
  fallbackTrackingData: {
    type: Object as PropType<StoryblokTrackingContent>,
    default: undefined,
  },
  target: {
    type: String as PropType<
      ('_blank' | '_self' | '_top' | '_parent') | undefined
    >,
    required: false,
    default: '_self',
  },
  theme: {
    type: Object as PropType<number | string>,
    required: false,
    default: undefined,
  },
})

const $currentShop = useCurrentShop()

const { trackPromotionClick } = await useTrackingEvents()

const trackingData = computed<StoryblokTrackingContent>(
  () =>
    (props.link?.promotion_id
      ? props.link
      : props.fallbackTrackingData) as StoryblokTrackingContent,
)

const clickObserver = (trackingData?: StoryblokTrackingContent) => {
  if (isStoryblokTrackingContent(trackingData)) {
    trackPromotionClick(trackingData)
  }
}

const theme = computed(() => (props.theme === 'light' ? 'light' : 'dark'))
</script>
